import { createSlice } from '@reduxjs/toolkit';

import history from 'config/history';

import api from 'api';

import { setVerified } from './profile';

export const initialPinState = {
  isLoading: false,
  error: null,
};

const pinSlice = createSlice({
  name: 'pin',
  initialState: initialPinState,
  reducers: {
    setPinLoading: (state) => {
      state.error = null;
      state.isLoading = true;
    },
    setPinSuccess: (state) => {
      state.isLoading = false;
    },
    setPinError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    updatePinLoading: (state) => {
      state.error = null;
      state.isLoading = true;
    },
    updatePinSuccess: (state) => {
      state.isLoading = false;
    },
    updatePinError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    verifyPinLoading: (state) => {
      state.error = null;
      state.isLoading = true;
    },
    verifyPinSuccess: (state) => {
      state.isLoading = false;
    },
    verifyPinError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  setPinLoading,
  setPinSuccess,
  setPinError,
  updatePinLoading,
  updatePinSuccess,
  updatePinError,
  verifyPinLoading,
  verifyPinSuccess,
  verifyPinError,
} = pinSlice.actions;

// SIDE EFFECTS
export function setPin(new_pin_code) {
  return (dispatch) => {
    dispatch(setPinLoading());

    api.pin
      .setPin(new_pin_code)
      .then((res) => {
        dispatch(setPinSuccess(res.data));
        dispatch(setVerified());
        history.push('/my-femtasy/account/age-verification/pin/update/success');
      })
      .catch((err) => {
        dispatch(setPinError(err));
      });
  };
}

export function updatePin(pin_code, new_pin_code) {
  return (dispatch) => {
    dispatch(updatePinLoading());

    api.pin
      .updatePin(pin_code, new_pin_code)
      .then((res) => {
        dispatch(updatePinSuccess(res.data));
        history.push('/my-femtasy/account/age-verification/pin/update/success');
      })
      .catch((err) => {
        dispatch(updatePinError(err));
      });
  };
}

export function verifyPin(pin_code) {
  return (dispatch) => {
    dispatch(verifyPinLoading());

    api.pin
      .verifyPin(pin_code)
      .then((res) => {
        dispatch(verifyPinSuccess(res.data));
        dispatch(setVerified());
        history.goBack();
      })
      .catch((err) => {
        dispatch(verifyPinError(err));
      });
  };
}

export default pinSlice.reducer;
